import { z } from 'zod'

export const recipeFormSchema = z.object({
  title: z.string().min(1, 'Titel is verplicht').max(255, 'Titel te lang'),
  description: z.string(),
  ingredients: z.array(z.string().min(1)).min(1, 'Minstens 1 ingrediënt vereist'),
  instructions: z.array(z.string().min(1)).min(1, 'Minstens 1 instructie vereist'),
  prep_time: z.number().min(0).nullable(),
  cook_time: z.number().min(0).nullable(),
  servings: z.number().min(1).max(50).nullable(),
  difficulty: z.enum(['gemakkelijk', 'middel', 'moeilijk', '']),
  meal_type: z.enum(['ontbijt', 'lunch', 'diner', 'snack', 'dessert', 'drankje', 'bijgerecht', '']),
  tags: z.array(z.string()),
  equipment: z.array(z.string()),
  image_url: z.string(),
  rating: z.number().min(1).max(5).nullable().optional(),
  notes: z.string(),
  is_public: z.boolean().optional(),
})

export type RecipeFormData = z.infer<typeof recipeFormSchema>
